import { useQuery, gql } from './graphql-provider';
import { Elm_Scale_Exercise_Bool_Exp, Elm_Scale_Exercise, Elm_Scale_Exercise_Insert_Input } from '../../../gen/types';
import { useMutation } from '@apollo/client';

const EXERCISES_QUERY = gql`
  query GetExercises($where: elm_scale_exercise_bool_exp) {
    exercises: elm_scale_exercise(where: $where) {
      config
      id
      mode_rel {
        value
        description
      }
      pitch_class_rel {
        value
        description
      }
      range_rel {
        value
        description
      }
    }
  }
`;

export function useQueryExercises({where}: {where: Elm_Scale_Exercise_Bool_Exp}) {
  const { loading, error, data } = useQuery<
    {exercises: Array<Elm_Scale_Exercise>},
    {where: Elm_Scale_Exercise_Bool_Exp}
  >(EXERCISES_QUERY, {
    fetchPolicy: 'network-only',
    variables: {where}
  });

  return {
    data,
    error,
    loading,
  };
}

const UPSERT_EXERCISE = gql`
  mutation UpsertExercise($input: elm_scale_exercise_insert_input!) {
  savedExercise: insert_elm_scale_exercise_one(object: $input, on_conflict: {constraint: scale_exercise_pkey, update_columns: config}) {
    id
    mode
    pitch_class
    range
    config
  }
}
`;

export function useSaveExercise() {
  const [saveExercise, { loading, error, data }] = useMutation<
    {savedExercise: Elm_Scale_Exercise},
    {input: Elm_Scale_Exercise_Insert_Input}
  >(UPSERT_EXERCISE);

  if (data) {
    data.savedExercise.__typename = undefined;
  }

  return {
    data,
    error,
    loading,
    saveExercise,
  };
}
